import { createSelector } from 'reselect';
import { Map } from 'immutable';

export const getOidc = (state) => state.get('oidc', new Map());

export const getOidcReducer = createSelector(
  [getOidc],
  oidc => oidc.get('oidcReducer', new Map())
);

export const getLogin = createSelector(
  [getOidc],
  oidc => oidc.get('login', new Map())
);

export const getIsLogged = createSelector(
  [getLogin],
  login => login.get('isLogged', false)
);

export const getUser = createSelector(
  [getOidcReducer],
  oidc => oidc.get('user', new Map()) || new Map()
);

export const getIdToken = createSelector(
  [ getUser ],
  (user) => user && user.get('id_token', undefined)
);

export const getAccessToken = createSelector(
  [ getUser ],
  (user) => user.get('access_token', undefined)
);

export const getFetchAuth = createSelector(
  [ getAccessToken ],
  (access_token) => {
    return {
      headers: {
        'Authorization': 'Bearer ' + access_token
      }
    };
  }
);
